<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <form @submit.prevent="passes(submitForm)">
      <div class="flex flex-wrap -mx-5">
        <d-field label="Project Name" class="w-full md:1/2 px-5">
          <d-input v-model="projectName" aria-label="project name" required />
        </d-field>
        <d-field label="QCP-issued Project Number" class="w-full md:1/2 px-5">
          <d-input v-model="projectNumber" aria-label="project number" required />
        </d-field>
        <d-field label="City" class="w-full md:w-1/3 px-5">
          <d-input v-model="companyCity" placeholder="The city for the design contractor" required />
        </d-field>
        <d-field label="Country" class="w-full md:w-1/3 px-5">
          <d-select v-model="contactCountry" expanded required>
            <option value="" disabled>
              Select a Country
            </option>
            <option v-for="country in countryOptions" :key="country.name" :value="country.name">
              {{ country.name }}
            </option>
          </d-select>
        </d-field>
        <d-field label="State/Province" class="w-full md:w-1/3 px-5">
          <d-select v-model="contactState" expanded required>
            <option value="" disabled>
              Select a State
            </option>
            <option v-for="state in availableStateOptions" :key="state.name" :value="state.abbreviation">
              {{ state.name }}
            </option>
          </d-select>
        </d-field>
        <d-field label="Project Completion Date" class="w-full md:w-1/2 px-5">
          <d-datepicker v-model="projectCompletionDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
        </d-field>
        <d-field label="Estimated Completion Date" class="w-full md:w-1/2 px-5">
          <d-datepicker v-model="estimatedCompletionDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
        </d-field>
        <d-field label="Final Contract Amount" rules="min_value:1" class="w-full md:w-1/2 px-5">
          <d-input v-model="finalContractAmount" aria-label="Final Contract Amount" required type="number" />
        </d-field>
        <d-field label="Your Company Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="yourCompanyName" aria-label="your company name" required />
        </d-field>
        <d-field label="Closeout information submitted by (your name)" class="w-full md:w-1/2 px-5">
          <d-input v-model="closeoutInformation" aria-label="Your Name" placeholder="Your Name" required />
        </d-field>
        <d-field label="Submitter Email" class="w-full md:w-1/2 px-5">
          <d-input v-model="submitterEmail" aria-label="Submitter email" placeholder="Your Email Address" required type="email" />
        </d-field>
      </div>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn type="submit" class="mx-5 md:mx-0" :loading="submitting">
          Submit
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_CLOSEOUT_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions, mapState, mapGetters } = createNamespacedHelpers('projectCloseoutForm');

  export default {
    computed: {
      ...mapFields({
        fields: ['projectName', 'projectNumber', 'companyCity', 'contactCountry', 'contactState', 'projectCompletionDate', 'estimatedCompletionDate', 'finalContractAmount', 'yourCompanyName', 'closeoutInformation', 'submitterEmail'],
        module: 'projectCloseoutForm',
        base: 'formFields',
        mutation: PROJECT_CLOSEOUT_FORM.FORM_FIELDS,
      }),
      ...mapState([
        'submitting',
      ]),

      ...mapGetters([
        'countryOptions',
        'stateProvinceOptions',
      ]),

      availableStateOptions() {
        return this.stateProvinceOptions(this.contactCountry);
      },
    },

    watch: {
      contactCountry() {
        this.contactState = '';
      },
    },

    methods: {
      ...mapActions([
        'submitForm',
      ]),
    },
  };
</script>